import Reveal from "@/components/base/Reveal";

const STEPS = [
  {
    icon: "ri-search-2-line",
    title: "Find your car",
    text: "Browse verified cars across Nairobi, Mombasa and Kisumu. Filter by city, budget, seats and transmission until you find the perfect match.",
  },
  {
    icon: "ri-calendar-check-line",
    title: "Book in minutes",
    text: "Pick your dates, review the transparent price breakdown, and confirm. Many hosts offer instant booking, so you can lock in your car right away.",
  },
  {
    icon: "ri-key-2-line",
    title: "Pick up and drive",
    text: "Meet your host, grab the keys and hit the road. Pay securely with M-Pesa, and message your host any time through the trip.",
  },
];

export default function HowItWorks() {
  return (
    <div id="how" className="mx-auto w-full max-w-7xl px-4 py-16 md:px-8 md:py-24">
      <Reveal className="max-w-2xl">
        <span className="text-sm font-medium uppercase tracking-[0.2em] text-primary-500">How it works</span>
        <h2 className="mt-3 font-heading text-3xl font-semibold text-foreground-950 md:text-4xl">
          Three steps between you and the open road
        </h2>
        <p className="mt-4 text-base leading-relaxed text-foreground-600">
          Gari keeps car rental simple and transparent — no paperwork queues, no hidden charges, no surprises.
        </p>
      </Reveal>

      <div className="mt-12 grid grid-cols-1 gap-6 md:grid-cols-3">
        {STEPS.map((step, index) => (
          <Reveal key={step.title} delay={index * 120}>
            <div className="relative h-full rounded-2xl surface-card p-6">
              <span className="absolute right-5 top-5 font-heading text-4xl font-semibold text-background-200">
                0{index + 1}
              </span>
              <span className="flex h-12 w-12 items-center justify-center rounded-xl bg-accent-500/15 text-2xl text-accent-400">
                <i className={step.icon}></i>
              </span>
              <h3 className="mt-5 font-heading text-lg font-semibold text-foreground-950">{step.title}</h3>
              <p className="mt-2 text-sm leading-relaxed text-foreground-600">{step.text}</p>
            </div>
          </Reveal>
        ))}
      </div>
    </div>
  );
}